import Indicator, { IndicatorType } from '../types/Indicator'

const SimpleMovingAverage: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'simpleMovingAverage',
  label: 'Simple Moving Average',
  nickname: 'SMA',
  fields: ['simpleMovingAverage', 'simpleMovingAverageAngle'],
  params: {
    field: 'close',
    period: 14,
  },
}

export default SimpleMovingAverage
